/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';

class TaggerView extends Backbone.View<Backbone.Model> {
  static initClass(): void {
    this.prototype.el = '#tagger';

    this.prototype.events = {
      // @ts-expect-error: Backbone events can be either the events hash or a method returning the events hash
      // The Backbone types do not know about this.
      'click .choose-file': 'clickFileInput',
      'change .file-input': 'updateFileName',
      'change select': 'updateSkip',
    };
  }

  updateSkip(e: JQueryEventObject): void {
    const skip = JSON.parse($(e.currentTarget).val()).skip;
    if (skip) {
      $(e.currentTarget).parents('tr').removeClass('danger').addClass('skip');
    } else {
      $(e.currentTarget).parents('tr').addClass('danger').removeClass('skip');
    }
  }

  updateFileName(e: JQueryEventObject): void {
    this.$el.find('.file-text-name').text($(e.currentTarget).val());
  }

  clickFileInput(): void {
    this.$el.find('.file-input').click();
  }

  override render(): this {
    return this;
  }
}
TaggerView.initClass();

export default TaggerView;
